import { theme } from '@global-engineering-shared/gweb-global-theme';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  modal: {
    width: '584px',
    height: 'fit-content',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    backgroundColor: 'white',
    position: 'absolute',
    alignSelf: 'center',
    justifySelf: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    height: '24px',
    fontSize: '16px',
    marginBottom: theme.spacing(2),
  },
  details: {
    height: '24px',
    fontSize: '14px',
    display: 'flex',
  },
  close: {
    alignSelf: 'flex-end',
    float: 'right',
  },
  separator: {
    backgroundColor: theme.palette.common.black,
    width: theme.spacing(0.5),
    height: theme.spacing(0.5),
    alignSelf: 'center',
    borderRadius: theme.spacing(1.25),
    margin: theme.spacing(0.5),
  },
  textSeparator: {
    height: '16px',
  },
});

export default useStyles;
